import { atom } from "jotai";

export const selectedSearchResultAtom = atom({
  word: "",
  activeType: ""
});
selectedSearchResultAtom.debugLabel = "selectedSearchResultAtom";
export type SelectedSearchResult = {
  word: string;
  activeType: string; //"venue" | "task" | "";
};
